import { useState, useEffect } from 'react';
import BlogWin from '../Components/BlogWin';
import quotes from '../quotes.json';

let bodyStyle = {
    backgroundImage: `url(/doujinarchive/img/windowbg.jpg)`,
    backgroundRepeat: `no-repeat`
};

export default function Post(props) {
    return(
        <div className='bottom-pad'>
            <BlogWin game={props.posts[props.post]}/>
        </div>
    );
}